import axios from "../../axios";

const getUsers = async () => {
  try {
    const { data } = await axios.get(`/users/`);
    console.log(data, "users");
    return data?.rows;
  } catch (e) {
    return null;
  }
};

export default { 
  getUsers 
};